import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const next = sessionStorage.getItem("po_next") || "/perfil";
    sessionStorage.removeItem("po_next");
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(next, { replace: true });
      })
      .catch((e) => {
        toast.error(errMsg(e));
        setUser(false);
        navigate("/entrar", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex flex-col items-center gap-4 py-24" data-testid="auth-callback">
      <Loader2 className="h-10 w-10 animate-spin text-orange-500" />
      <p className="text-lg text-slate-700">Entrando...</p>
    </div>
  );
}
